import { computed, inject, Injectable, Injector, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../workflow-registry-diagnostics/workflow-draft-confirmation.service';

/** Calendar edit ownership stays separate from the workflow editor's pending document. */
@Injectable({ providedIn: 'root' })
export class BusinessCalendarDraftStateService {
  private readonly injector = inject(Injector);
  private readonly dirty = signal(false);
  private readonly busy = signal(false);
  readonly isDirty = this.dirty.asReadonly();
  readonly isOperationInProgress = this.busy.asReadonly();
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());
  setDirty(value: boolean): void {
    this.dirty.set(value);
  }
  setOperationInProgress(value: boolean): void {
    this.busy.set(value);
  }
  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.injector.get(WorkflowDraftConfirmationService).confirm({
      heading: 'Leave calendar draft?',
      message:
        'Unsaved calendar draft changes will be lost if you leave this page.',
      confirmText: 'Leave without saving',
      cancelText: 'Stay on page',
    });
  }
}
